import React, { useEffect, useState } from "react";
import AccountLayout from "./AccountLayout";
import { t } from "i18next";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import NoData from "../../component/NoData";

const RealTimeBonus = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    status: "active",
    page: 1,
    limit: 100,
  });

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getTurnover, filter);
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
  };

  //   useEffect(() => {
  //     getData();
  //   }, []);

  return (
    <AccountLayout title={t("RealTimeBonus")}>
      <ng-component className="ng-star-inserted">
        <router-outlet />
        <ng-component
          _nghost-serverapp-c2794537353
          className="ng-tns-c2794537353-13 ng-star-inserted"
        >
          <div
            _ngcontent-serverapp-c2794537353
            className="player-top ng-tns-c2794537353-13"
          >
            <div
              _ngcontent-serverapp-c2794537353
              className="tab-btn-section ng-tns-c2794537353-13"
            >
              <app-tab-button-nav
                _ngcontent-serverapp-c2794537353
                className="ng-tns-c2794537353-13"
                _nghost-serverapp-c1328719065
              >
                <div
                  _ngcontent-serverapp-c1328719065
                  className="tab-btn tab-btn-page"
                >
                  <div
                    _ngcontent-serverapp-c1328719065
                    className="line"
                    style={{
                      width: "calc(50%)",
                      "-webkit-transform": "translate(0%, 0px)",
                      "-ms-transform": "translate(0%, 0px)",
                      transform: "translate(0%, 0px)",
                    }}
                  />
                  <div
                    _ngcontent-serverapp-c1328719065
                    drctablinkactive="active"
                    className="btn ng-star-inserted active"
                    data-tab-current="current"
                  >
                    <div _ngcontent-serverapp-c1328719065 className="text">
                      {t("Rebate")}
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c1328719065
                    drctablinkactive="active"
                    className="btn ng-star-inserted"
                    data-tab-current
                  >
                    <div _ngcontent-serverapp-c1328719065 className="text">
                      {t("Rescue")}
                    </div>
                  </div>
                </div>
                <div
                  _ngcontent-serverapp-c1328719065
                  className="tab-btn-page-underline"
                />
              </app-tab-button-nav>
            </div>
          </div>

          <div
            _ngcontent-serverapp-c514414220
            className="tab-content tab-content-page"
          >
            <router-outlet _ngcontent-serverapp-c1266201197 />
            <ng-component className="ng-star-inserted">
              <div className="real-time-bonus-wrap ng-star-inserted">
                <div className="menu-box available-amount">
                  <div
                    className="available-amount__bg"
                    style={{
                      "background-image":
                        'url("/assets/NewImages/bg-available-amount.webp?v=1776751585885")',
                    }}
                  />
                  <div className="available-amount__title">
                    <div
                      className="available-amount__icon"
                      style={{
                        "mask-image":
                          'url("/assets/NewImages/icon-available-amount.webp?v=1776751585885")',
                      }}
                    />
                    <div className="available-amount__text">
                      {" "}
                      {t("AvailableAmount")}{" "}
                    </div>
                  </div>
                  <div
                    className="available-amount__decor"
                    style={{
                      "background-image":
                        'url("/assets/NewImages/deco-available-amount.webp?v=1776751585885")',
                    }}
                  />
                  <div className="available-amount__value"> ৳0 </div>

                  <div className="button available-amount__button ng-star-inserted">
                    <a>{t("PlayGames")}</a>
                  </div>
                </div>
                <div className="menu-box">
                  <div className="claimed-box">
                    <div className="claimed-box__item">
                      <div className="claimed-box__title">{t("ClaimedToday")}</div>
                      <div className="claimed-box__value"> ৳0 </div>
                    </div>
                    <div className="claimed-box__item">
                      <div className="claimed-box__title">
                        {" "}
                        {t("ClaimedThisWeek")}{" "}
                      </div>
                      <div className="claimed-box__value"> ৳0 </div>
                    </div>
                  </div>
                </div>
                <div className="menu-box">
                  <div className="bonus-summary-box">
                    <div className="bonus-summary__title">
                      <h2>
                        <span>{t("Summary")}</span>
                      </h2>
                    </div>
                  </div>
                  <mcd-tab-items>
                    <div className="tab-btn-block ng-star-inserted">
                      <div className="tab-btn tab-btn-page tab-real-time-bonus">
                        <div
                          className="line"
                          style={{
                            width: "calc(25%)",
                            "-webkit-transform": "translate(0%, 0px)",
                            "-ms-transform": "translate(0%, 0px)",
                            transform: "translate(0%, 0px)",
                          }}
                        />
                        <div
                          mcdtablinkactive="active"
                          className="btn active ng-star-inserted"
                        >
                          <div className="text ng-star-inserted">{t("Today")}</div>
                        </div>
                        <div
                          mcdtablinkactive="active"
                          className="btn ng-star-inserted"
                        >
                          <div className="text ng-star-inserted">
                            {t("Yesterday")}
                          </div>
                        </div>
                        <div
                          mcdtablinkactive="active"
                          className="btn ng-star-inserted"
                        >
                          <div className="text ng-star-inserted">
                            {t("Last7Days")}
                          </div>
                        </div>
                        <div
                          mcdtablinkactive="active"
                          className="btn ng-star-inserted"
                        >
                          <div className="text ng-star-inserted">
                            {t("OptionalDate")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </mcd-tab-items>
                  <mcd-no-data
                    _nghost-serverapp-c3013389467
                    className="ng-star-inserted"
                  >
                    <div _ngcontent-serverapp-c3013389467 className="no-result">
                      <div _ngcontent-serverapp-c3013389467 className="pic">
                        <img
                          _ngcontent-serverapp-c3013389467
                          alt="no-data"
                          src="/assets/NewImages/no-data.webp?v=1776751585885&source=mcdsrc"
                          loading="lazy"
                        />
                      </div>
                      <div
                        _ngcontent-serverapp-c3013389467
                        className="text ng-star-inserted"
                      >
                        {" "}
                        {t("NoData")}{" "}
                      </div>
                    </div>
                  </mcd-no-data>
                </div>
              </div>

              <mat-date-range-input
                role="group"
                className="mat-date-range-input ng-untouched ng-pristine ng-valid"
                style={{ display: "none" }}
                id="mat-date-range-input-5"
                data-mat-calendar="mat-datepicker-5"
              >
                <div
                  cdkmonitorsubtreefocus
                  className="mat-date-range-input-container"
                >
                  <div className="mat-date-range-input-wrapper">
                    <input
                      type="text"
                      matstartdate
                      mcdmaterialdateformats
                      formcontrolname="startDate"
                      className="mat-start-date mat-date-range-input-inner ng-untouched ng-pristine ng-valid"
                      aria-haspopup="dialog"
                      min="2026-04-05T07:43:05.939Z"
                      max="2026-05-05T07:43:05.939Z"
                    />
                    <span
                      aria-hidden="true"
                      className="mat-date-range-input-mirror"
                    />
                  </div>
                  <span className="mat-date-range-input-separator mat-date-range-input-separator-hidden">
                    –
                  </span>
                  <div className="mat-date-range-input-wrapper mat-date-range-input-end-wrapper">
                    <input
                      type="text"
                      matenddate
                      mcdmaterialdateformats
                      formcontrolname="endDate"
                      className="mat-end-date mat-date-range-input-inner ng-untouched ng-pristine ng-valid"
                      aria-haspopup="dialog"
                      min="2026-04-05T07:43:05.939Z"
                      max="2026-05-05T07:43:05.939Z"
                    />
                    <span
                      aria-hidden="true"
                      className="mat-date-range-input-mirror"
                    />
                  </div>
                </div>
              </mat-date-range-input>
              <mat-datepicker-toggle
                matsuffix
                className="mat-datepicker-toggle"
                style={{ display: "none" }}
                data-mat-calendar="mat-datepicker-5"
              >
                <button
                  mat-icon-button
                  type="button"
                  mat-ripple-loader-uninitialized
                  mat-ripple-loader-class-name="mat-mdc-button-ripple"
                  className="mdc-icon-button mat-mdc-icon-button mat-unthemed mat-mdc-button-base"
                  mat-ripple-loader-centered
                  aria-haspopup="dialog"
                  aria-label="Open calendar"
                  tabIndex={0}
                >
                  <span className="mat-mdc-button-persistent-ripple mdc-icon-button__ripple" />
                  <svg
                    viewBox="0 0 24 24"
                    width="24px"
                    height="24px"
                    fill="currentColor"
                    focusable="false"
                    aria-hidden="true"
                    className="mat-datepicker-toggle-default-icon ng-star-inserted"
                  >
                    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
                  </svg>

                  <span className="mat-mdc-focus-indicator" />
                  <span className="mat-mdc-button-touch-target" />
                </button>
              </mat-datepicker-toggle>
              <mat-date-range-picker touchui style={{ display: "none" }} />
            </ng-component>
          </div>
        </ng-component>
      </ng-component>
    </AccountLayout>
  );
};

export default RealTimeBonus;
